function ActionBtnItem({
	icon = "",
	big = false,
	onClick = () => {},
	tooltip = "",
	layout = "",
	iconLayout = "maskInteractive",
	disabled = false,
}) {
	return (
		<button
			type="button"
			className={`main_comp_action_btn ${layout} ${disabled ? "disabled" : ""}`}
			disabled={disabled}
			aria-label={tooltip || "Azione"}
			onClick={(e) => {
				e.stopPropagation();
				onClick(e);
			}}
			data-tooltip-id="tooltip_small_top"
			data-tooltip-offset={10}
			data-tooltip-content={tooltip}
		>
			<span
				className={`default ${iconLayout === "maskInteractive" ? "icon_mask !bg-interactive-100" : iconLayout} ${icon + (big ? " icon_24" : " icon_16")}`}
			></span>
		</button>
	);
}

export default ActionBtnItem;
